import { render, staticRenderFns } from "./ActivityFormsView.vue?vue&type=template&id=009d1a28&scoped=true&lang=pug&"
import script from "./ActivityFormsView.vue?vue&type=script&lang=ts&"
export * from "./ActivityFormsView.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityFormsView.vue?vue&type=style&index=0&id=009d1a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009d1a28",
  null
  
)

export default component.exports